import React from "react";
import './header.css';
import logo from './logo.png';
import {BrowserRouter as Router} from 'react-router-dom';
import { HashLink as Link} from 'react-router-hash-link';
const Header = () =>{
    return(
        <Router>
        <header className="header">
            <article className="header__logo">
               <img src= {logo} alt= "" />
            </article>
            <article className="header__navbar">
            <Link to="#aboutme" smooth>
            About
        </Link>
        <Link to="#skill" smooth>
            Skills
        </Link>
        <Link to="#project" smooth>
            Project
        </Link>
        <Link to="#contact" smooth>
            Contact
        </Link>
            </article>
        </header>
        </Router>
    );
}

export default React.memo(Header);